export default __webpack_public_path__ + "static/CSS-3e38652c25af4146f8107e4083017005.jpg";